
const BackgroundElements = () => {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Subtle bubble effects */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-yellow-400/20 rounded-full blur-3xl animate-pulse-gentle"></div>
      <div className="absolute top-40 right-20 w-24 h-24 bg-white/20 rounded-full blur-2xl animate-pulse-gentle delay-1000"></div>
      <div className="absolute bottom-32 left-1/4 w-40 h-40 bg-purple-300/30 rounded-full blur-3xl animate-pulse-gentle delay-2000"></div>
    </div>
  );
};

export default BackgroundElements;
